module.exports = __webpack_public_path__ + "static/media/desktop_info.1998ad5c.jpg";